/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { useEffect, useState } from "react";

import {
	ICountryBrandApplicationContext,
	useCountryBrandApplicationContext,
} from "../../contexts/CountryBrandApplicationContextProvider";
import { UIEvents } from "../../UIEvents";

function StafHired() {
	const { currentStep, countryBrandApplication, update, formRef, setPreviousStep } =
		useCountryBrandApplicationContext() as ICountryBrandApplicationContext;

	const {
		staffHiredFirstQuestion,
		staffHiredSecondQuestion,
		staffHiredThirdQuestion,
		staffHiredFemalePercentage,
		staffHiredSeniority,
	} = countryBrandApplication;

	const [showInput, setShowInput] = useState(staffHiredSecondQuestion === "NO");

	useEffect(() => {
		setPreviousStep(currentStep - 1);
		function submitStepData() {
			const formElement = formRef.current as HTMLFormElement;
			const staffHiredFirstQuestion = formElement.elements.firstQuestion.value;
			const staffHiredSecondQuestion = formElement.elements.secondQuestion.value;
			const staffHiredThirdQuestion = formElement.elements.thirdQuestion.value;
			const staffHiredFemalePercentage = formElement.elements.femalePercentage.value;
			const staffHiredSeniority = formElement.elements.staffHiredSeniority?.value ?? "";

			update({
				data: {
					staffHiredFirstQuestion,
					staffHiredSecondQuestion,
					staffHiredThirdQuestion,
					staffHiredFemalePercentage,
					staffHiredSeniority,
				},
				nextStep: currentStep + 1,
			});
		}

		document.addEventListener(UIEvents.builtInFormValidateSucess, submitStepData);

		return () => {
			document.removeEventListener(UIEvents.builtInFormValidateSucess, submitStepData);
		};
	}, []);

	return (
		<div className="step-page" id="step-5">
			<section>
				<h3>5 - Personal de la empresa</h3>
				<table>
					<thead>
						<tr>
							<th></th>
							<th>Si</th>
							<th>No</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>
								<p>
									¿La organización tiene operaciones en Uruguay y mantiene una planilla en la que al
									menos un 75% de sus trabajadores son uruguayos?
								</p>
							</td>
							<td>
								<input
									type="radio"
									value="SI"
									name="firstQuestion"
									defaultChecked={staffHiredFirstQuestion === "SI"}
								/>
							</td>
							<td>
								<input
									type="radio"
									value="NO"
									name="firstQuestion"
									defaultChecked={staffHiredFirstQuestion === "NO"}
								/>
							</td>
						</tr>
						<tr id="td-5b">
							<td>
								<p>
									¿La organización tiene operaciones en Uruguay y al menos un 50% de sus acciones
									pertenecen a uruguayos o empresas conformadas por capital uruguayo? En caso de no
									cumplirse este criterio indicar antigüedad de las operaciones en Uruguay
								</p>
								{showInput && (
									<input
										type="text"
										name="staffHiredSeniority"
										defaultValue={staffHiredSeniority}
										required={true}
									/>
								)}
							</td>
							<td>
								<input
									type="radio"
									value="SI"
									name="secondQuestion"
									defaultChecked={staffHiredSecondQuestion === "SI"}
									onClick={() => {
										setShowInput(false);
									}}
								/>
							</td>
							<td>
								<input
									type="radio"
									value="NO"
									name="secondQuestion"
									defaultChecked={staffHiredSecondQuestion === "NO"}
									onClick={() => {
										setShowInput(true);
									}}
								/>
							</td>
						</tr>
						<tr>
							<td>
								<p>
									¿La organización tiene operaciones en Uruguay que implican el pago de impuestos
									tributarios, patentes municipales o cargas sociales, cuyo pago demuestra al día al
									momento de la evaluación?
								</p>
							</td>
							<td>
								<input
									type="radio"
									value="SI"
									name="thirdQuestion"
									defaultChecked={staffHiredThirdQuestion === "SI"}
								/>
							</td>
							<td>
								<input
									type="radio"
									value="NO"
									name="thirdQuestion"
									defaultChecked={staffHiredThirdQuestion === "NO"}
								/>
							</td>
						</tr>
					</tbody>
				</table>
				<label htmlFor="femalePercentage">
					<p>Total del personal de la empresa, porcentaje de personal femenino *</p>
					<input
						type="number"
						min="0"
						max="100"
						step="1"
						name="femalePercentage"
						defaultValue={staffHiredFemalePercentage}
						required
					/>
				</label>
			</section>
		</div>
	);
}

export { StafHired };
